function EvolutionTab() {
  return <div>Evolution</div>;
}

export default EvolutionTab;
